import React from "react";

export const NavigationItemsContext = React.createContext({
  isCollapsed: false,
});
